{
  "BUSINESS_GARDEN": "Business Garden",
  "INCUBATOR": "Incubator",
  "SIVA_PROGRAMADMIN": "Siva - Program admin",
  "OWI_ACTOR": "One way in actor",
  "NCE_OUTSIDE_NIC": "NCE - Outside NIC",
  "NCE": "NCE",
  "ARENA": "Arena",
  "BUSINESS_NETWORK": "Business network",
  "CLUSTER_INITIATIVE": "Cluster initiative",
  "MODNE_KLYNGER": "Mature clusters",
  "ARENA_PRO": "Arena Pro",
  "NETWORK": "Network",
  "GCE": "GCE",
  "NIC_KLYNGE_2025": "Norwegian Innovation Cluster"
}
